module.exports = __webpack_public_path__ + "static/img/foot-logo.3bce43e.png";